import React from 'react'
import { ICellRendererParams } from 'ag-grid-enterprise'
import { EnhancedStatementRow } from '../../../../utils/dataEnhancement'

export const DimensionGroupNameCellRenderer: React.FC<ICellRendererParams<EnhancedStatementRow>> = ({ value }) => {
  return <div>{value}</div>
}
